// extracted by mini-css-extract-plugin
module.exports = {"publications":"Publications_publications__RCHip","moreButton":"Publications_moreButton__tCFpt"};